export default function onEnter(action = () => {}) {
    const event = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            action();
        }
    };
    window.addEventListener('keypress', event);

    function removeListener() {
        window.removeEventListener('keypress', event);
    }

    return removeListener;
}
